module.exports = __webpack_public_path__ + "img/file-powerpoint.e929f46d.svg";